import React, { useEffect, useRef, useState } from 'react'
import caretDown from '../../../SearchFilters/GenericDropDown/imagesGenericDropdown/caretDownGeneric.svg'
import useStore from '../../BusinessStore/Store'
import styles from './styles.module.css'

function PrimaryCategories () {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const { primaryCategories, setPrimaryCategories, isQueryLoading } = useStore()
  const [localCategories, setLocalCategories] = useState(primaryCategories)
  const dropdownRef = useRef(null)
  const timeoutId = useRef(null)

  const categoryOptions = [
    'Accommodation & Food Services',
    'Administrative Support Waste Management & Remediation',
    'Agriculture',
    'Arts Entertainment & Recreation',
    'Construction',
    'Educational Services',
    'Finance & Insurance',
    'Healthcare & Social Assistance',
    'Information',
    'Management of Companies & Enterprises',
    'Manufacturing',
    'Mining Quarrying & Oil & Gas Extraction',
    'Other Services',
    'Professional Scientific & Technical Services',
    'Public Administration',
    'Real Estate Rental & Leasing',
    'Retail',
    'Transportation & Warehousing',
    'Utilities'
  ]

  useEffect(() => {
    setLocalCategories(primaryCategories)
  }, [primaryCategories])

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false)
      }
    }

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      clearTimeout(timeoutId)
      // clearTimeout(timeoutId.current)
    }
  }, [isDropdownOpen])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPrimaryCategories(localCategories.length === 0 ? ['Any'] : localCategories)
    }, 1500) // Debounced state update

    return () => clearTimeout(timeout)
  }, [localCategories, setPrimaryCategories])

  const handleDropdownToggle = () => {
    if (!isQueryLoading) {
      setIsDropdownOpen(!isDropdownOpen)
    }
  }

  const handleCategorySelection = option => {
    const updatedCategories =
      option === 'Any' ? ['Any'] : updateCategorySelection(option)
    setLocalCategories(updatedCategories)
  }

  const updateCategorySelection = option => {
    const filteredOptions = localCategories.filter(o => o !== 'Any')
    return filteredOptions.includes(option)
      ? filteredOptions.filter(o => o !== option)
      : [...filteredOptions, option]
  }

  const generateDropdownLabel = () => {
    if (localCategories.length === 0 || localCategories[0] === 'Any') {
      return 'Any'
    }
    return localCategories.length === 1
      ? localCategories[0]
      : `${localCategories[0]} +${localCategories.length - 1} more`
  }

  useEffect(() => {
    if (isQueryLoading) {
      setIsDropdownOpen(false)
    }
  }, [isQueryLoading])

  return (
    <div className={styles.formControlCategories}>
      <label className={styles.labelCategories}>Primary Categories</label>
      <div className={styles.dropdownCategories} ref={dropdownRef}>
        <button
          type='button'
          className={`${styles.dropdownButtonCategories} ${
            isQueryLoading ? styles.disabledCategories : ''
          }`}
          onClick={handleDropdownToggle}
          disabled={isQueryLoading}
        >
          {generateDropdownLabel()}
          <span className={styles.arrowCategories}>
            <img
              src={caretDown}
              alt='arrow'
              style={{ width: '8px', height: '15px', paddingTop: '3px' }}
            />
          </span>
        </button>
        {isDropdownOpen && (
          <div className={styles.dropdownContentCategories}>
            {['Any', ...categoryOptions].map(option => (
              <div
                key={option}
                className={
                  option === 'Any'
                    ? styles.anyCheckboxContainerCategories
                    : styles.checkboxContainerCategories
                }
              >
                <input
                  type='checkbox'
                  className={styles.checkboxCategories}
                  id={`primaryCategories-${option}`}
                  name='primaryCategories-option'
                  value={option}
                  checked={localCategories.includes(option)}
                  onChange={() => handleCategorySelection(option)}
                  disabled={isQueryLoading}
                />
                <label
                  htmlFor={`primaryCategories-${option}`}
                  className={styles.checkboxLabelCategories}
                >
                  {option}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default PrimaryCategories
